import MainStepNewScsBiz2 from "./MainStepNewScsBiz2";

export default MainStepNewScsBiz2;